import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Facebook, MessageCircle } from 'lucide-react';

const Footer = () => {
  return (
    <footer style={{
      background: 'var(--bg-card)',
      borderTop: '1px solid var(--border-light)',
      marginTop: '5rem',
      padding: '3rem 0 1.5rem'
    }}>
      <div className="container">
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: '2rem',
          marginBottom: '2rem'
        }}>
          {/* Company Info */}
          <div>
            <h3 className="heading-3" style={{ marginBottom: '1rem' }}>
              VAE Accompagnement
            </h3>
            <p className="body-small" style={{ marginBottom: '1rem', lineHeight: '1.6' }}>
              Votre partenaire de confiance pour la validation de vos acquis professionnels.
              Un accompagnement personnalisé vers la réussite.
            </p>
            <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
              <a href="https://www.facebook.com/share/1Dehn6vwGn/" target="_blank" rel="noopener noreferrer" 
                style={{ color: 'var(--text-primary)', transition: 'color 0.2s ease' }}
                data-testid="footer-facebook">
                <Facebook size={20} />
              </a>
              <a href="https://wa.me/33688399624" target="_blank" rel="noopener noreferrer"
                style={{ color: '#25D366', transition: 'color 0.2s ease' }}
                data-testid="footer-whatsapp">
                <MessageCircle size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="heading-3" style={{ marginBottom: '1rem' }}>
              Liens Rapides
            </h4>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li style={{ marginBottom: '0.5rem' }}>
                <Link to="/programs" className="body-small" style={{ 
                  textDecoration: 'none', 
                  color: 'var(--text-secondary)',
                  transition: 'color 0.2s ease'
                }}>
                  Nos Formations VAE
                </Link>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <Link to="/booking" className="body-small" style={{ 
                  textDecoration: 'none', 
                  color: 'var(--text-secondary)',
                  transition: 'color 0.2s ease'
                }}>
                  Réserver une Séance
                </Link>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <Link to="/faq" className="body-small" style={{ 
                  textDecoration: 'none', 
                  color: 'var(--text-secondary)',
                  transition: 'color 0.2s ease'
                }}>
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h4 className="heading-3" style={{ marginBottom: '1rem' }}>
              Nos Diplômes
            </h4>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li style={{ marginBottom: '0.5rem' }}>
                <span className="body-small" style={{ color: 'var(--text-secondary)' }}>CAP AEPE</span>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <span className="body-small" style={{ color: 'var(--text-secondary)' }}>DEAP</span>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <span className="body-small" style={{ color: 'var(--text-secondary)' }}>DEAS</span>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <span className="body-small" style={{ color: 'var(--text-secondary)' }}>DEEJE</span>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <span className="body-small" style={{ color: 'var(--text-secondary)' }}>CAFERUIS</span>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <span className="body-small" style={{ color: 'var(--text-secondary)' }}>BAC ASSP</span>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <span className="body-small" style={{ color: 'var(--text-secondary)' }}>Titre Professionnel IEPE</span>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="heading-3" style={{ marginBottom: '1rem' }}>
              Contact
            </h4>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li style={{ marginBottom: '0.75rem', display: 'flex', alignItems: 'flex-start', gap: '0.5rem' }}>
                <Mail size={18} style={{ marginTop: '0.2rem', flexShrink: 0 }} />
                <a href="mailto:apdr.vae@gmail.com" className="body-small" style={{ 
                  textDecoration: 'none', 
                  color: 'var(--text-secondary)',
                  transition: 'color 0.2s ease'
                }}>
                  apdr.vae@gmail.com
                </a>
              </li>
              <li style={{ marginBottom: '0.75rem', display: 'flex', alignItems: 'flex-start', gap: '0.5rem' }}>
                <Phone size={18} style={{ marginTop: '0.2rem', flexShrink: 0 }} />
                <a href="tel:+33688399624" className="body-small" style={{ 
                  textDecoration: 'none', 
                  color: 'var(--text-secondary)',
                  transition: 'color 0.2s ease'
                }}>
                  06 88 39 96 24
                </a>
              </li>
              <li style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem' }}>
                <MessageCircle size={18} style={{ marginTop: '0.2rem', flexShrink: 0, color: '#25D366' }} />
                <a href="https://wa.me/33688399624" target="_blank" rel="noopener noreferrer" className="body-small" style={{ 
                  textDecoration: 'none', 
                  color: 'var(--text-secondary)',
                  transition: 'color 0.2s ease'
                }}>
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{
          borderTop: '1px solid var(--border-light)',
          paddingTop: '1.5rem',
          marginTop: '2rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '1rem'
        }}>
          <p className="caption" style={{ margin: 0 }}>
            © 2025 VAE Accompagnement. Tous droits réservés. — SIREN : 833 761 133
          </p>
          <div style={{ display: 'flex', gap: '1.5rem' }}>
            <Link to="/legal" className="caption" style={{ 
              textDecoration: 'none', 
              color: 'var(--text-muted)',
              transition: 'color 0.2s ease'
            }}>
              Mentions légales
            </Link>
            <Link to="/privacy" className="caption" style={{ 
              textDecoration: 'none', 
              color: 'var(--text-muted)',
              transition: 'color 0.2s ease'
            }}>
              Politique de confidentialité
            </Link>
            <Link to="/terms" className="caption" style={{ 
              textDecoration: 'none', 
              color: 'var(--text-muted)',
              transition: 'color 0.2s ease'
            }}>
              Conditions d'utilisation
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
